/** What we ask a large fleet to send. Order is the order a broker wants to read them in. */
export interface PacketItem {
  label: string
  detail: string
  /** Only 'Helpful' renders a chip — 'Needed' is the unlabelled default. */
  importance: 'Needed' | 'Helpful'
}

export const PACKET_ITEMS: PacketItem[] = [
  {
    label: 'Driver list or licenses',
    detail: 'Names, license numbers and states, dates of birth, and hire dates.',
    importance: 'Needed',
  },
  {
    label: 'Equipment list',
    detail: 'Trucks and trailers with VIN, year, make, and value. A spreadsheet is fine.',
    importance: 'Needed',
  },
  {
    label: 'Loss run reports',
    detail:
      'Last 3–5 years, from every insurance provider you have been with. Documents need to be from within the last 30 days.',
    importance: 'Needed',
  },
  {
    label: 'Current policy or declarations page',
    detail:
      "We'll study your current deductibles and limits, and try to match them with the quotes we provide.",
    importance: 'Helpful',
  },
  {
    label: 'IFTA return',
    detail: 'Most recent quarterly IFTA return is recommended.',
    importance: 'Helpful',
  },
]

export const PACKET_ACCEPT = '.pdf,.csv,.xlsx,.xls,.jpg,.jpeg,.png,.doc,.docx,.zip'
export const PACKET_MAX_SIZE_MB = 25

export interface TravelRangeOption {
  name: string
  /** Rendered lighter than the name; `name (range)` reproduces the Django choice label exactly. */
  range: string
  value: string
}

/** Mirrors InsuranceApplication.TravelDistance — the same values the application question submits. */
export const TRAVEL_RANGE_OPTIONS: TravelRangeOption[] = [
  { name: 'Local', range: '0–50 miles', value: 'LOCAL' },
  { name: 'Regional', range: '51–150 miles', value: 'REGIONAL' },
  { name: 'Extended regional', range: '151–300 miles', value: 'EXTENDED_REGIONAL' },
  { name: 'Long haul', range: '300+ miles', value: 'LONG_HAUL' },
]
